<template>
  <section id="introduction" class="uk-padding-large-bottom"
            v-if="introduction_donations.list">

    <div class="uk-box-shadow-small" v-observe-visibility="visibilityChanged">
      <div class="uk-container uk-container-large uk-margin-large uk-margin-remove-top uk-padding-large uk-position-relative">
        <p>Abgeschlossene Patenschaften</p>
        <progress class="uk-progress" v-bind:value="animatedProgressPrice" max="1"></progress>
        <div class="uk-position-relative">
          <span v-if="!$apollo.queries.takenPipes.loading" v-bind:style="'position: absolute; left:' + animatedProgressPrice * 100 + '%; transform: translateX(-40%);'">
            {{parseInt(animatedTakenPipes)}} Pfeifen</span>
        </div>
        <p class="uk-text-right">Vielen Dank!</p>

        <transition>
          <div class="uk-text-center uk-position-bottom-center uk-margin-small-bottom"
                v-show="$apollo.queries.takenPipes.loading"
          >
            <div data-uk-spinner="ratio: 0.8;"></div>
            <span class="uk-margin-small-left uk-text-small">aktualisiere Fortschritt...</span>
          </div>
        </transition>
      </div>
    </div>

    <div class="uk-container uk-container-large"
          v-for="s in introduction_donations.list" v-bind:key="s.id">

      <div class="uk-flex uk-flex-column">
        <div class="uk-text-lead uk-align-center uk-width-1-2@l" v-html="s.body_text"></div>
        <router-link to="/pate-werden" class="uk-button uk-button-default uk-button-large uk-text-large uk-align-center">
          {{s.button_text_four}}
        </router-link>
        <router-link to="/paten" class="uk-button-text uk-align-center uk-text-center">
          {{s.button_text_three}}
        </router-link>
        <div class="uk-text-lead uk-align-center uk-width-1-2@l" v-html="s.body_text_2"></div>
        <div class="uk-align-center uk-width-1-2@l">
          <div class="uk-child-width-1-2@m uk-grid uk-flex-center" data-uk-grid>
            <div v-if="s.button_text_one">
              <router-link to="/spenden" class="uk-button uk-button-default uk-button-large uk-text-large uk-align-center">
                {{s.button_text_one}}
              </router-link>
            </div>
            <div v-if="s.button_text_two">
              <a href="#explanation-organs" v-on:click.prevent="scrollTo('#explanation-organs')" class="uk-button uk-button-default uk-button-large uk-text-large uk-align-center">
                {{s.button_text_two}}
              </a>
            </div>
            <div v-if="s.pdf_file[0]">
              <a class="uk-button-text uk-align-center uk-text-center"
                  type="application/octet-stream"
                  v-bind:href="s.pdf_file[0].httpUrl"
                  v-bind:download="s.pdf_file[0].description"
              >{{s.pdf_file[0].description}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {INTRODUCTION, TOTAL_PIPES, TAKEN_PIPES, SPONSORSHIP_LIST} from '../../constants/graphql'
import {Power2, TweenLite} from 'gsap'
import _ from 'lodash'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'

export default {
  name: 'Introduction',
  data () {
    return {
      introduction_donations: {},
      totalPipes: 0,
      takenPipes: {},
      pipeSubtotals: [
        { price: 1500, count: 72, subtotal: 108000 },
        { price: 1000, count: 39, subtotal: 39000 },
        { price: 500, count: 108, subtotal: 54000 },
        { price: 250, count: 284, subtotal: 71000 },
        { price: 100, count: 425, subtotal: 42500 },
        { price: 50, count: 356, subtotal: 17800 }
      ],
      sponsorshipList: {},
      grandTotal: 0,
      subTotal: 0,
      progressVisible: false,
      progressPrice: 0,
      progressPipes: 0,
      tweenedProgressPrice: 0,
      tweenedProgressPipes: 0,
      tweenedTakenPipes: 0,
      loading: 0
    }
  },
  apollo: {
    introduction_donations: {
      query: INTRODUCTION
    },
    sponsorshipList: {
      query: SPONSORSHIP_LIST,
      update (data) {
        return data.repeater_sponsor_list_repeater.list
      }
    },
    totalPipes: {
      query: TOTAL_PIPES,
      update (data) {
        return data.pipe.getTotal
      },
      result ({ data, loader, networkStatus }) {
        this.calculateProgress()
      },
      loadingKey: 'loading'
    },
    takenPipes: {
      query: TAKEN_PIPES,
      update (data) {
        return data.pipe
      },
      result ({ data, loader, networkStatus }) {
        this.calculateProgress()
      },
      loadingKey: 'loading'
    }
  },
  computed: {
    animatedProgressPrice: function () {
      return this.tweenedProgressPrice
    },
    animatedProgressPipes: function () {
      return this.tweenedProgressPipes
    },
    animatedTakenPipes: function () {
      return this.tweenedTakenPipes
    }
  },
  methods: {
    scrollTo (id) {
      TweenLite.to(window, 2.4, {
        scrollTo: id,
        ease: Power2.easeOut
      })
    },
    visibilityChanged (isVisible, entry) {
      this.progressVisible = isVisible
      if (isVisible) {
        if (!this.$apollo.queries.takenPipes.loading) {
          this.$apollo.queries.takenPipes.refetch()
        }
      } else {
        this.progressPipes = 0
        this.tweenedTakenPipes = 0
      }
    },
    openModal () {
      this.$modal.show('sponsorship-list')
    },
    hideModal () {
      this.$modal.hide('sponsorship-list')
    },
    fetchData () {
      this.$apollo.queries.takenPipes.refetch()
    },
    calculateProgress () {
      let grandTotal = 0
      _.forEach(this.pipeSubtotals, (pipe) => {
        grandTotal += pipe.subtotal
      })
      this.grandTotal = grandTotal
      let subtotal = 0
      _.forEach(this.takenPipes.list, (pipe) => {
        subtotal += pipe.price_ref.list[0].amount
      })
      this.subTotal = subtotal
      // Preis-Fortschritt
      this.progressPrice = (((subtotal * 100) / grandTotal) / 100) * 3
      if (this.totalPipes > 0 && this.takenPipes.getTotal > 0) {
        // Pfeifen-Fortschritt
        this.progressPipes = ((this.takenPipes.getTotal * 100) / this.totalPipes) / 100
      }
    }
  },
  watch: {
    '$route': 'fetchData',
    progressPrice (newProgress, oldProgress) {
      // console.log('watch progress')
      TweenLite.fromTo(this.$data, 1.5,
        { tweenedProgressPrice: 0 },
        { tweenedProgressPrice: newProgress, ease: Power2.easeInOut }
      )
    },
    progressPipes (newProgress, oldProgress) {
      // console.log('watch progress')
      // console.info(newProgress)
      TweenLite.fromTo(this.$data, 1.5,
        { tweenedProgressPipes: 0 },
        { tweenedProgressPipes: newProgress, ease: Power2.easeInOut }
      )
      TweenLite.fromTo(this.$data, 1.5,
        { tweenedTakenPipes: 0 },
        { tweenedTakenPipes: this.takenPipes.getTotal, ease: Power2.easeInOut }
      )
    }
  },
  mounted () {
    this.$apollo.queries.takenPipes.refetch()
  }
}
</script>
<style lang="scss">
  .scale-enter-active, .scale-leave-active {
    transition: opacity .5s, transform 0.5s;
  }
  .scale-enter, .scale-leave-to {
    opacity: 0;
    transform: scale(0.5);
  }
  #introduction {
    margin-top: 4em;
  }
  .uk-button-large {
    padding: 0.5rem 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage/Introduction.vue